'use strict';

import ValidatedForm from 'flight/ui/validated-form';

$(function() {
    ValidatedForm.attachTo('form[name="design_transfer_agreement"]');
});



// WEBPACK FOOTER //
// ./src/js/page/design-transfer-agreement.js